import { render, staticRenderFns } from "./PaperMag.vue?vue&type=template&id=6dbad91a&scoped=true&"
import script from "./PaperMag.vue?vue&type=script&lang=js&"
export * from "./PaperMag.vue?vue&type=script&lang=js&"
import style0 from "./PaperMag.vue?vue&type=style&index=0&id=6dbad91a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbad91a",
  null
  
)

export default component.exports